export const Paths = {
  onboard: "/onboard",
  dashboard: "/dashboard",
};
